import { GET_CITIES_ERROR, GET_CITIES_LOADING, GET_CITIES_SUCCESS, GET_COUNTRIES_ERROR, GET_COUNTRIES_LOADING, GET_COUNTRIES_SUCCESS, GET_STATES_ERROR, GET_STATES_LOADING, GET_STATES_SUCCESS } from './actionTypes';

// get countries
const getCountriesLoading = () => {
  return {
    type: GET_COUNTRIES_LOADING,
  };
};

const getCountriesSuccess = (data) => {
  return {
    type: GET_COUNTRIES_SUCCESS,
    payload: data,
  };
};

const getCountriesError = (error) => {
  return {
    type: GET_COUNTRIES_ERROR,
    payload: error,
  };
};

// get states
const getStatesLoading = () => {
  return {
    type: GET_STATES_LOADING,
  };
};

const getStatesSuccess = (data) => {
  return {
    type: GET_STATES_SUCCESS,
    payload: data,
  };
};

const getStatesError = (error) => {
  return {
    type: GET_STATES_ERROR,
    payload: error,
  };
};

// get cities
const getCitiesLoading = () => {
  return {
    type: GET_CITIES_LOADING,
  };
};

const getCitiesSuccess = (data) => {
  return {
    type: GET_CITIES_SUCCESS,
    payload: data,
  };
};

const getCitiesError = (error) => {
  return {
    type: GET_CITIES_ERROR,
    payload: error,
  };
};

export {
    getCountriesLoading,
    getCountriesSuccess,
    getCountriesError,

    getStatesLoading,
    getStatesSuccess,
    getStatesError,

    getCitiesLoading,
    getCitiesSuccess,
    getCitiesError,
};
